if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"mgm-identity-oidc-app","remotes":[{"alias":"web_mfe_shell","name":"web_mfe_shell","entry":"https://www.mgmresorts.com/shell/_next/static/chunks/remoteEntry.js","shareScope":"default"}],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return /^7[79]2$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}